module.exports = __webpack_public_path__ + "img/index_card_selfGa.f3366708.svg";